import { eachDayOfInterval, endOfYear, isBefore, isSameYear } from "date-fns";
import { chain } from "lodash";

const datesToInterval = (date1: Date, date2: Date) => {
  return isBefore(date1, date2)
    ? { start: date1, end: date2 }
    : { start: date2, end: date1 };
};

export const millesimeHasEveryDay = (
  millesime: number,
  files: (
    | {
        startDate?: Date;
        endDate?: Date;
      }
    | undefined
  )[],
  creationDate?: string
): boolean => {
  const millesimeDate = new Date(millesime, 0, 1);
  const createdAt = new Date(creationDate || millesimeDate);
  const entrepriseCreatedInMillesime = createdAt.getFullYear() === millesime;
  const requiredInterval = datesToInterval(
    entrepriseCreatedInMillesime ? createdAt : millesimeDate,
    endOfYear(millesimeDate)
  );

  const requiredDays = eachDayOfInterval(requiredInterval);

  const coveredDays = chain(files)
    .flatMap((file) => {
      if (!file?.startDate || !file?.endDate) return [];
      const fileInterval = datesToInterval(
        new Date(file.startDate),
        new Date(file.endDate)
      );

      return eachDayOfInterval(fileInterval);
    })
    .filter((day) => isSameYear(day, millesimeDate))
    .uniqBy((day) => day.toISOString())
    .value();

  const coveredDaySet = new Set(coveredDays.map((d) => d.toISOString()));

  return requiredDays.every((d) => coveredDaySet.has(d.toISOString()));
};
